import { Row } from '@lightningjs/ui-components';
import { Router, Utils } from '@lightningjs/sdk';

// Components
import EditProfilesButton from './components/EditProfilesButton';
import AuthRoute from '../../components/layouts/AuthRoute/AuthRoute';
import Lightning from '@lightningjs/sdk/src/Lightning';
export default class Profile extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Wrapper: {
        x: 0,
        y: 0,
        h: 1080,
        w: 1920,
        Title: {
          y: 200,
          w: 1920,
          text: {
            textAlign: 'center',
            text: "Who's Watching?",
            fontSize: 53,
          },
        },
        Profiles: {
          collision: true,
          y: 350,
          w: 1920,
          h: 240,
          flex: {
            direction: 'row',
            justifyContent: 'center',
          },
          type: Row,
          style: {
            itemSpacing: 50,
          },
          plinko: true,
        },
      },
      EditProfilesButton: {
        collision: true,
        type: EditProfilesButton,
      },
    };
  }

  get id() {
    return 'ProfilePage';
  }

  get _Profiles() {
    return this.tag('Wrapper.Profiles');
  }

  _firstActive() {
    this._setState('Profiles');
  }

  _handleBack() {
    const history = Router.getHistory();
    const lastRoute = history.length > 0 ? history[history.length - 1].hash : false;

    if (
      lastRoute === 'login-with-password' ||
      lastRoute === 'login-online' ||
      lastRoute === 'profile/create-profile'
    ) {
      // EXIT DIALOG
      Router.navigate('settings/exit');
    } else {
      const token = localStorage.getItem('userToken');
      if ((token && lastRoute !== 'login-with-password') || lastRoute === 'login-online') {
        Router.back();
      }
    }
  }

  $setIndex(index) {
    this._Profiles.selectedIndex = index;
  }

  $setState(state) {
    this._setState(state);
  }

  static _states() {
    return [
      class Profiles extends this {
        _getFocused() {
          return this._Profiles;
        }
        _handleDown() {
          this._setState('EditProfilesButton');
        }
      },
      class EditProfilesButton extends this {
        _getFocused() {
          return this.tag('EditProfilesButton');
        }
        _handleUp() {
          this._setState('Profiles');
        }

        _handleClick() {
          this._handleEnter();
        }
        _handleEnter() {
          this.navigate('profile/edit-profiles');
        }
      },
    ];
  }
}
